export default __webpack_public_path__ + "static/media/machining.27516ea0.jpg";